import client from 'helpers/client';

export default function favoriteGamesQuery(variables) {
  return client.graphQuery(`query FavoriteGamesQuery($date: ISO8601Date, $genderSport: GenderSportEnum, $level: LevelEnum, $organizationId: ID, $power25: Boolean, $state: StateEnum) {
  currentUser {
  favoriteGames(
    date: $date
    genderSport: $genderSport
    organizationId: $organizationId
    level: $level
    power25: $power25
    state: $state
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    nodes {
      ...scoreboardGameWithPower25
      ...scoreboardGameFanApp
    }
  }
}

}

fragment scoreboardGameWithPower25 on GameInterface {
  ...scoreboardGame
gameTeams {
  power25Ranking: teamRanking(formula: POWER_25, stateEnum: $state) {
    place
  }
}

}

fragment scoreboardGame on GameInterface {
  id
gameTeams {
  id
  isLoser
  isTbd
  isWinner
  picks
  pregameStanding {
    overallRecord
  }
  scoreText
  team {
    image
    name
    state {
      abbrev
    }
  }
}
contest {
  hometownTicketingUrl
  gofanTicketingUrl
  nfhsNetworkUrl(type: STATE)
  expectedStatus
}
date
longStatusText
statusId
titleText
webPath
webPhotosPath
webRecapPath
webScorebookCastPath

}

fragment scoreboardGameFanApp on GameInterface {
  id
contest {
  hometownTicketingUrl
  gofanTicketingUrl
  nfhsNetworkUrl(type: STATE)
}
date
gameTeams {
  id
  isLoser
  isTbd
  isWinner
  pregameStanding {
    overallRecord
  }
  scoreText
  team {
    image
    mascot
    name
    state {
      abbrev
    }
  }
}
gameTypeLabel
longStatusText
statusId
webPath

}

`, variables);
}